<template>
  <div class="venue-container">
    <div class="venue-info">
      <h1>Conference Location: Chon Buri, Thailand</h1>
      <h1>Venue and Accommodation: The Zign Hotel</h1>
      <p>
        The Zign Hotel in Pattaya, Chonburi, Thailand, is an excellent choice for an International Conference of Tropical Plants. Its strengths lie in extensive conference facilities. It can accommodate a large international delegation on-site, simplifying logistics. Strategically located about 80-90 minutes from Suvarnabhumi Airport (BKK), it offers good international accessibility. The hotel's beachfront setting in tropical Thailand, combined with proximity to relevant attractions like Nong Nooch Tropical Garden, provides an authentic and engaging environment perfectly suited to a tropical plant conference. While slightly removed from Pattaya's bustling center, this can be an advantage for a focused event.
      </p>
      <div class="venue-link-box">
            <a class="venue-link" href="https://reservation.travelanium.net/hotelpage/rates/?propertyId=623&onlineId=4&pid=MDgxNzY1Ng%3D%3D&accesscode=ICTP2026&_gl=1*1urjwpj*_gcl_au*OTI1NjYyODg1LjE3NjU4NzIyODg.&_ga=2.261555787.732226159.1766040140-964894791.1765872288" target="_blank">Hotel Reservation</a>
      </div>
    </div>

    <div class="photos">
      <img src="../../assets/images/Venue1.png" alt="Photo 1" class="photo" />
      <img src="../../assets/images/Venue2.png" alt="Photo 2" class="photo" />
      <img src="../../assets/images/Venue3.png" alt="Photo 3" class="photo" />
    </div>

  </div>
</template>
<script>
export default {
  name: 'Venue',
};
</script>

<style scoped>
/* 主要容器样式 */
.venue-container {
  width: 66%; /* 设置容器宽度为66% */
  margin: 0 auto; /* 水平居中对齐 */
  padding: 20px; /* 内边距 */
  text-align: left; /* 文字左对齐 */
}

/* 酒店信息样式 */
.venue-info {
  margin-bottom: 20px; /* 信息与照片之间的间距 */
}

h1 {
  font-size: 1.5em; /* 中等字体 */
  margin: 5px 0; /* 上下间距 */
}

h2 {
  font-size: 1.5em; /* 中等字体 */
  margin: 5px 0; /* 上下间距 */
}

/* 照片容器样式 */
.photos {
  display: block; /* 使用块级布局 */
  margin-bottom: 20px; /* 照片与交通路线之间的间距 */
}

.photo {
  width: 100%; /* 设置照片宽度为容器宽度的100% */
  height: auto; /* 高度自适应 */
  border-radius: 8px; /* 圆角边框 */
  margin-bottom: 10px; /* 照片间距 */
}

h3 {
  font-size: 1.2em; /* 较大的字体 */
  margin-bottom: 10px; /* 标题与内容之间的间距 */
}

.venue-link-box {
    margin-top: 20px;
}

.venue-link {
    font-size: 1.3rem;
    color: blue;
}

.venue-link:hover {
    color: green;
    text-decoration: underline;
}
</style>
